<template>
  <el-container  style="display: block;">
    <el-row  class="tui-el" style="margin-top: 20px;text-align: center;">
      <el-input v-model="seachName" style="width: 150px;float: left;margin-left: 1%;margin-top: 10px;" placeholder="请输入功能名称"></el-input>
      <el-button type="primary" style="background-color: #409eff;float: left;margin-left: 10px;margin-top: 10px;"  @click="loadlist()" round>搜索</el-button>
      <h1 style="margin-right: 1%;"> 功能项开关分布</h1>

    </el-row>
    <el-row  class="tui-el">
      <el-table
          :data="tableData"
          border

          :cell-style="cellStyle"
          style="width: 98%;margin-top: 10px;margin-left: 1%;"
          height="1050">
          <el-table-column
            fixed
            prop="name"
            label="功能名称"
            width="180">
          </el-table-column>
          <el-table-column
            label="WS"
            style="text-align: center;"
            width="180">
            <el-table-column
              width="80"
              label="WS状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.wss > 0" @click="aropen(scope.row.l_id,2,13,scope.row.name,'WS')">开</div>
                   <div  v-if="scope.row.wss == 0" @click="aropen(scope.row.l_id,1,13,scope.row.name,'WS')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="WS数量"
               >
               <template slot-scope="scope" >
                   <div >{{scope.row.wss}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="G1"
            width="180">
            <el-table-column
              width="80"
              label="G1状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.g1s > 0" @click="aropen(scope.row.l_id,2,14,scope.row.name,'G1')">开</div>
                   <div  v-if="scope.row.g1s == 0" @click="aropen(scope.row.l_id,1,14,scope.row.name,'G1')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="G1数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.g1s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="LS"
            width="180">
            <el-table-column
              width="80"
              label="LS状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.lss > 0" @click="aropen(scope.row.l_id,2,1,scope.row.name,'LS')">开</div>
                   <div  v-if="scope.row.lss == 0" @click="aropen(scope.row.l_id,1,1,scope.row.name,'LS')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="LS数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.lss}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="BS"
            width="180">
            <el-table-column
              width="80"
              label="BS状态"
               >
               <template slot-scope="scope">
                   <div>关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="BS数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.bss}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="A1"
            width="180">
            <el-table-column
              width="80"
              label="A1状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.a1s > 0" @click="aropen(scope.row.l_id,2,4,scope.row.name,'A1')">开</div>
                   <div  v-if="scope.row.a1s == 0" @click="aropen(scope.row.l_id,1,4,scope.row.name,'A1')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="A1数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.a1s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="XS1"
            width="180">
            <el-table-column
              width="80"
              label="XS1状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.xs1s > 0" @click="aropen(scope.row.l_id,2,2,scope.row.name,'XS1')">开</div>
                   <div  v-if="scope.row.xs1s == 0" @click="aropen(scope.row.l_id,1,2,scope.row.name,'XS1')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="XS1数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.xs1s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="S1"
            width="180">
            <el-table-column
              width="80"
              label="S1状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.s1s > 0" @click="aropen(scope.row.l_id,2,8,scope.row.name,'S1')">开</div>
                   <div  v-if="scope.row.s1s == 0" @click="aropen(scope.row.l_id,1,8,scope.row.name,'S1')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="S1数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.s1s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="K1"
            width="180">
            <el-table-column
              width="80"
              label="K1状态"
               >
               <template slot-scope="scope">
                  <div  v-if="scope.row.k1s > 0" @click="aropen(scope.row.l_id,2,6,scope.row.name,'K1')">开</div>
                  <div  v-if="scope.row.k1s == 0" @click="aropen(scope.row.l_id,1,6,scope.row.name,'K1')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="K1数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.k1s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="XS2"
            width="180">
            <el-table-column
              width="80"
              label="XS2状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.xs2s > 0" @click="aropen(scope.row.l_id,2,3,scope.row.name,'XS2')">开</div>
                   <div  v-if="scope.row.xs2s == 0" @click="aropen(scope.row.l_id,1,3,scope.row.name,'XS2')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="XS2数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.xs2s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="A2"
            width="180">
            <el-table-column
              width="80"
              label="A2状态"
               >
               <template slot-scope="scope">
                  <div  v-if="scope.row.a2s > 0" @click="aropen(scope.row.l_id,2,5,scope.row.name,'A2')">开</div>
                  <div  v-if="scope.row.a2s == 0" @click="aropen(scope.row.l_id,1,5,scope.row.name,'A2')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="A2数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.a2s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="A3"
            width="180">
            <el-table-column
              width="80"
              label="A3状态"
               >
               <template slot-scope="scope">
                  <div  v-if="scope.row.a3s > 0" @click="aropen(scope.row.l_id,2,10,scope.row.name,'A3')">开</div>
                  <div  v-if="scope.row.a3s == 0" @click="aropen(scope.row.l_id,1,10,scope.row.name,'A3')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="A3数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.a3s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="K2"
            width="180">
            <el-table-column
              width="80"
              label="K2状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.k2s > 0" @click="aropen(scope.row.l_id,2,7,scope.row.name,'K2')">开</div>
                   <div  v-if="scope.row.k2s == 0" @click="aropen(scope.row.l_id,1,7,scope.row.name,'K2')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="K2数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.k2s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="K3"
            width="180">
            <el-table-column
              width="80"
              label="K3状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.k3s > 0" @click="aropen(scope.row.l_id,2,11,scope.row.name,'K3')">开</div>
                   <div  v-if="scope.row.k3s == 0" @click="aropen(scope.row.l_id,1,11,scope.row.name,'K3')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="K3数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.k3s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="G2"
            width="180">
            <el-table-column
              width="80"
              label="G2状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.g2s > 0" @click="aropen(scope.row.l_id,2,15,scope.row.name,'G2')">开</div>
                   <div  v-if="scope.row.g2s == 0" @click="aropen(scope.row.l_id,1,15,scope.row.name,'G2')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="G2数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.g2s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="S2"
            width="180">
            <el-table-column
              width="80"
              label="S2状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.s2s > 0" @click="aropen(scope.row.l_id,2,12,scope.row.name,'S2')">开</div>
                   <div  v-if="scope.row.s2s == 0" @click="aropen(scope.row.l_id,1,12,scope.row.name,'S2')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="S2数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.s2s}}</div>
               </template>
            </el-table-column>
          </el-table-column>
          <el-table-column

            label="I"
            width="180">
            <el-table-column
              width="80"
              label="I状态"
               >
               <template slot-scope="scope">
                   <div  v-if="scope.row.is > 0" @click="aropen(scope.row.l_id,2,9,scope.row.name,'I')">开</div>
                   <div  v-if="scope.row.is == 0" @click="aropen(scope.row.l_id,1,9,scope.row.name,'I')">关</div>
               </template>
            </el-table-column>
            <el-table-column
              width="80"
              label="I数量"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.is}}</div>
               </template>
            </el-table-column>
          </el-table-column>
        </el-table>
    </el-row>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      >
      <span>是否确认<span style="font-size: 20px;color: red;">{{state}}</span><span style="font-size: 30px;">--{{nameg}}</span><span style="font-size: 25px;">--{{namef}}</span>分词数据？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doAropen()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>






</template>

<script>
  export default {
    data() {
       return {
          seachName:'',
          tableData:[],
          dialogVisible:false,
          state:'打开',
          nameg:'',
          namef:'',
          lid:0,
          o:1,
          t:0,



      }
    },
  directives: {
    },
    created() {
       this.loadlist()
    },

  methods:{
    aropen(lid,o,t,nameg,namef){
      this.lid = lid
      this.o = o
      if(o == 1){
        this.state = '打开'
      }else{
        this.state = '关闭'
      }
      this.t = t
      this.nameg = nameg
      this.namef = namef
      this.dialogVisible = true
    },
    doAropen(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		lid:this.lid,
          o:this.o,
          t:this.t
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/aropen'
      })
      .then(res=>{
      	if(res.data.code == 200){
          this.loadlist()
          this.dialogVisible = false

      	}else{
      		alert('修改失败')
      	}

      })
      .catch(err=>{

      });
    },
    cellStyle(row,column,rowIndex,columnIndex){//根据报警级别显示颜色
       // console.log(row)
       // console.log(row.column)
       if((row.column.label==="WS状态"||row.column.label==="WS数量")&& row.row.wss > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="G1状态"||row.column.label==="G1数量")&& row.row.g1s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="LS状态"||row.column.label==="LS数量")&& row.row.lss > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="BS状态"||row.column.label==="BS数量")&& row.row.bss > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="A1状态"||row.column.label==="A1数量")&& row.row.a1s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="XS1状态"||row.column.label==="XS1数量")&& row.row.xs1s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="S1状态"||row.column.label==="S1数量")&& row.row.s1s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="K1状态"||row.column.label==="K1数量")&& row.row.k1s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="XS2状态"||row.column.label==="XS2数量")&& row.row.xs2s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="A2状态"||row.column.label==="A2数量")&& row.row.a2s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="A3状态"||row.column.label==="A3数量")&& row.row.a3s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="K2状态"||row.column.label==="K2数量")&& row.row.k2s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="K3状态"||row.column.label==="K3数量")&& row.row.k3s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="G2状态"||row.column.label==="G2数量")&& row.row.g2s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="S2状态"||row.column.label==="S2数量")&& row.row.s2s > 0){
         return 'background:#6efdf0'
       }else if((row.column.label==="I状态"||row.column.label==="I数量")&& row.row.is > 0){
         return 'background:#6efdf0'
       }
    },

    loadlist(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.seachName
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/arstate'
      })
      .then(res=>{
      	this.tableData = res.data;

      })
      .catch(err=>{

      });
    }


  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/arstate.vue